// @ts-ignore
import { applyMiddleware, compose, createStore as _createStore } from 'redux';
import { createBrowserHistory } from 'history';
// @ts-ignore
import rootSaga from '../sagas/index';
import rootReducer from '../redux/index';

import middleware, { sagaMiddleware } from './middleware';

const composeEnhancer =  compose;
const history = createBrowserHistory();
const configStore = (initialState = {}) => {
	const store = _createStore(rootReducer(history), initialState, composeEnhancer(applyMiddleware(...middleware)));

	sagaMiddleware.run(rootSaga);

	return {
		store,
	};
};

const { store } = configStore();

export { store };